// DEPRECATED - use channel specific files
import React, { useContext, useEffect } from 'react';
import proptypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ready } from './publisher';
import './collection-info-tabs.scss';
import { dataModel } from '../dataModel';
import { CollectionInfoTabsDesktop } from './CollectionInfoTabsDesktop';
import { CollectionInfoTabsMobile } from './CollectionInfoTabsMobile';

const { string } = proptypes;

export const CollectionInfoTabs = ({ collectionId }) => {
  useEffect(() => {
    ready();
  }, []);

  const { channel } = useContext(ExperienceContext);

  if (channel === 'mobile') {
    return (
      <CollectionInfoTabsMobile collectionId={collectionId} />
    );
  }

  return (
    <CollectionInfoTabsDesktop collectionId={collectionId} />
  );
};

CollectionInfoTabs.displayName = 'CollectionInfoTabs';

CollectionInfoTabs.dataModel = dataModel;

CollectionInfoTabs.propTypes = {
  collectionId: string.isRequired
};
